import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import SearchBar from "@/components/SearchBar";
import TripsSection from "@/components/TripsSection";
import CartSidebar from "@/components/CartSidebar";
import Footer from "@/components/Footer";
import { useTrips } from "@/hooks/useTrips";

const Index = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { data: trips } = useTrips();
  const location = useLocation();

  // Handle smooth scroll to trips section when hash is present
  useEffect(() => {
    if (location.hash === "#trips") {
      setTimeout(() => {
        const element = document.getElementById("trips");
        if (element) {
          const headerOffset = 80; // Account for fixed header
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 100);
    }
  }, [location.hash]);

  // Handle anchor link clicks
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a[href^="#"]');
      
      if (link) {
        const href = link.getAttribute('href');
        if (href === "#trips") {
          e.preventDefault();
          const element = document.getElementById("trips");
          if (element) {
            const headerOffset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <CartSidebar />
      <main>
        <Hero />
        <HowItWorks />
        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
        <TripsSection
          searchTerm={searchTerm}
        />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
